import { Injectable } from '@angular/core';

const MACHINE_LEARNING_RESET_KPIS = {
  gigatestServiceTestCurlTimeNameLookup: { friendlyname: '(Service test) DNS resolution time' },
  gigatestServiceTestCurlTimeClient: { friendlyname: '(Service test) Client response time' },
  gigatestServiceTestCurlTimeNetwork: { friendlyname: '(Service test) Network response time' },
  gigatestServiceTestCurlTimeServer: { friendlyname: '(Service test) Server response time' }
};

@Injectable({
  providedIn: 'root'
})
export class MlResetKpiDataService {
  constructor() {} //eslint-disable-line

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  getAllKpi(): Array<any> {
    return Object.keys(MACHINE_LEARNING_RESET_KPIS).map(key => ({
      key,
      value: MACHINE_LEARNING_RESET_KPIS[key]
    }));
  }
}
